<template>
    <fieldset style="margin: -20px 0 40px 0;" v-show="payment_method === 'upn'">
        <div class="col-sm-12">
            <h4>Podatki za UPN nalog:</h4>
            <table class="table table-user-information">
                <tbody>
                <tr>
                    <td>Koda namena:</td>
                    <td><b>GDSV</b></td>
                </tr>
                <tr>
                    <td>Namen plačila</td>
                    <td><b>Plačilo obroka za naročilo 8028</b></td>
                </tr>
                <tr>
                    <td>Znesek</td>
                    <td><b>{{model.price_total}}€</b></td>
                </tr>
                <tr>
                    <td>IBAN</td>
                    <td><b>SI56 2900 0005 0904 875</b></td>
                </tr>
                <tr>
                    <td>Referenca</td>
                    <td><b>SI00 8028</b></td>
                </tr>
                <tr>
                    <td>Ime in priimek / naziv</td>
                    <td><b>ZAVOD SAVINA ATAI</b></td>
                </tr>
                <tr>
                    <td>Ulica in hišna številka</td>
                    <td><b>Golnik 067</b></td>
                </tr>
                <tr>
                    <td>Pošta in kraj</td>
                    <td><b>4204 Golnik</b></td>
                </tr>
                <tr>
                    <td>Država</td>
                    <td><b>Slovenija</b></td>
                </tr>

                </tbody>
            </table>
        </div>
    </fieldset>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "schema", "order", "payment_method"],


        created() {
            Event.$on("braintree_payment_method_changed", function (model) {
                this.payment_method = model.payment_method;
            }.bind(this));
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/ObrokiUPN.vue